import "./suporte.2c201a09.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8648"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8648"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $6KOho = parcelRequire("6KOho");
$6KOho.support.cors = true;
function $d13ef56c86fbfa73$var$objectifyForm(formArray) {
    //serialize data function
    var returnArray = {};
    for(var i = 0; i < formArray.length; i++)returnArray[formArray[i]['name']] = formArray[i]['value'];
    return returnArray;
}
const $d13ef56c86fbfa73$var$send = (body)=>{
    const data = {
        type: 'support',
        subject: 'Suporte',
        ...$d13ef56c86fbfa73$var$objectifyForm(body)
    };
    $6KOho.ajax({
        type: 'POST',
        url: 'https://api.clubedotruco.com.br/messages',
        data: JSON.stringify(data),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
    });
};
$6KOho(function() {
    const form = $6KOho('#form-support');
    const success = $6KOho('#alert-success');
    $6KOho('#close-alert').on('click', function(e) {
        e.preventDefault();
        success.addClass('hidden');
        window.location.href = '/';
    });
    form.on('submit', function(e) {
        e.preventDefault();
        const textareaValue = $6KOho('#message').val().trim();
        if (textareaValue === '') {
            alert('Por favor, insira uma mensagem.');
            return false;
        }
        $d13ef56c86fbfa73$var$send($6KOho(this).serializeArray());
        success.removeClass('hidden');
        return false;
    });
});


//# sourceMappingURL=suporte.8c2c2163.js.map
